import { NgComponentOutlet } from '@angular/common';
import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  inject,
  Injector,
  input,
  signal,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import {
  EWidget,
  IWidgetExceptionalCaseInformation,
  TWidgetParameters,
  WIDGET_INPUTS,
} from 'scw-digital-boards-widgets';
import { ELoadStatus } from '../../../../state/state.interface';
import { addWidgetConfiguration } from '../../dashboard-constants.class';

@Component({
  imports: [NgComponentOutlet],
  selector: 'app-widget-catalog-item',
  styleUrl: './widget-catalog-item.component.scss',
  templateUrl: './widget-catalog-item.component.html',
})
export class WidgetCatalogItemComponent implements AfterViewInit {
  private readonly translate = inject(TranslateService);
  @ViewChild('preview', { static: true }) preview!: ElementRef<HTMLDivElement>;

  public widgetType = input.required<EWidget>();

  public readonly componentBuildData = computed(() => {
    try {
      const widgetType = this.widgetType();
      const widgetParameters: TWidgetParameters = {
        appliedFilters: signal({ filters: [], modeName: 'default' }),
        // @ts-ignore
        configuration:
          widgetType === EWidget.navigation
            ? new BehaviorSubject({ hyperlinkUrl: '', middleTitle: this.translate.instant('widget.navigation.name') })
            : new BehaviorSubject({}),
        dataLoadStatusSubject: new BehaviorSubject<ELoadStatus>(ELoadStatus.initial),
        exceptionalCaseInformationSubject: new BehaviorSubject<IWidgetExceptionalCaseInformation[]>([]),
        isDummyMode: new BehaviorSubject(true),
        lastDataLoadDateSubject: new BehaviorSubject<string | null>(''),
        refreshInterval: new BehaviorSubject<number>(-1),
        refreshSubject: new BehaviorSubject<null>(null),
      };

      return {
        component: addWidgetConfiguration[widgetType].component,
        injector: Injector.create({
          providers: [
            {
              provide: WIDGET_INPUTS,
              useValue: widgetParameters,
            },
          ],
        }),
      };
    } catch (_) {
      return null;
    }
  });

  public ngAfterViewInit(): void {
    this.scaleChildIfTooTall();
  }

  private scaleChildIfTooTall(): void {
    const container: HTMLElement | null = this.preview.nativeElement.parentElement;
    const child: HTMLElement | null = this.preview.nativeElement.firstElementChild as HTMLElement;

    if (!child || !container) {
      return;
    }

    const containerHeight: number = container.offsetHeight;
    const childHeight: number = child.offsetHeight / 2;

    if (childHeight > containerHeight) {
      this.preview.nativeElement.classList.add('scaled');
    }
  }
}
